import React, { useState, useEffect } from 'react';
import { withRouter } from "react-router-dom";
import { Card, CardBody, Col, Row, Label } from 'reactstrap';
import { connect } from "react-redux";
import { SlButton, TextInput, SlPageTitle, SlDropdown, SlFormEntryRow, SlSectionLabel, SlRadioButton } from '../editors';
import { metadataService, newLoanService, SessionService } from "../../_services";
import { newLoanActions } from "../../_actions";
import validator from "validator";

const leapTheoryForm = (props) => {
    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        email: "",
        dob: "",
        zip: "",
        city: "",
        state: "",
        address: "",
        monthsAtAddress: 0,
        homeOwnership: "",
        driversLicense: "",
        driversLicenseState: "",
        cellPhone: "",
        homePhone: "",
        ssn: "",
        employmentType: "",
        employerName: "",
        military: 0,
        monthsEmployed: 0,
        monthlyIncome: "",
        payFrequency: "",
        nextPayDate: "",
        secondPayDate: "",
        workPhone: "",
        payType: "direct_deposit",
        monthsAtBank: 0,
        bankName: "",
        bankAccountType: "",
        bankAccountNumber: "",
        bankRoutingNumber: "",
        loanAmount: 0,
        test: props.leapTheoryTest,
    });
    const [isStateSelectOpen, setStateSelectOpen] = useState(false);
    const [fieldErrors, setFieldErrors] = useState([]);
    const [formError, setFormError] = useState(true);

    useEffect(() => {
        const registrationInfo = SessionService.getPersonalInfo();
        if (registrationInfo) {
            setFormData(prev => ({
                ...prev,
                firstName: registrationInfo.firstName,
                lastName: registrationInfo.lastName,
                email: registrationInfo.email,
                dob: registrationInfo.dateOfBirth,
                zip: registrationInfo.postalCode,
                city: registrationInfo.city,
                state: registrationInfo.state,
                address: registrationInfo.address1,
                monthsAtAddress: registrationInfo.years * 12 + registrationInfo.months,
                homeOwnership: registrationInfo.rentOrOwn == 0 ? "rent" : "own", //check 0 rent 1 own
                driversLicenseState: registrationInfo.state,
                cellPhone: registrationInfo.mobileNumber,
                homePhone: registrationInfo.mobileNumber,
                ssn: registrationInfo.socialSecurityNumber,
                loanAmount: registrationInfo.requestedAmount,
            }))
        }
        if (props.employers.length > 0) {
            const employer = props.employers.reduce((max, current) => (current.value > max.value ? current : max), props.employers[0]);
            getPayPeriods(employer.payFrequency);
            setFormData(prev => ({
                ...prev,
                employmentType: "employed",
                employerName: employer.employerName,
                military: 0,
                monthsEmployed: Number(employer.years) * 12 + Number(employer.months),
                monthlyIncome: employer.incomePerPeriod,
                workPhone: employer.workNumber,
                payType: "direct_deposit",
            }))
        }
        else if (props.incomes.length > 0) {
            const income = props.incomes.reduce((max, current) => (current.value > max.value ? current : max), props.incomes[0]);
            getPayPeriods("4");
            const otherIncome = getOtherIncomeSource(income.otherIncomeSource);
            setFormData(prev => ({
                ...prev,
                employmentType: "benefits",
                employerName: otherIncome,
                military: 0,
                monthsEmployed: 0,
                monthlyIncome: income.incomePerPeriod,
                workPhone: formData.cellphone,
                payType: "direct_deposit",
            }))
        }
        formHasError();
    }, [])

    function getOtherIncomeSource(incomeSource) {
        switch (incomeSource) {
            case 4:
                return "Child Support";
            case 5:
                return "Alimony";
            case 6:
                return "Social Security";
            case 7:
                return "Other";
            default:
                return "";
        }
    }


    function getPayPeriods(frequency) {
        const today = new Date();
        const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
        const lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        const firstPayDate = new Date(firstDayOfMonth);
        const secondPayDate = new Date(firstDayOfMonth);
        let freq = "";

        const adjustForWeekend = (date) => {
            const day = date.getDay();
            if (day === 0) date.setDate(date.getDate() - 2); // Sunday -> Friday
            if (day === 6) date.setDate(date.getDate() - 1); // Saturday -> Friday
            return date;
        };

        const isPast = (date) => date < today;

        switch (frequency) {
            case "1": //Weekly
                firstPayDate.setDate(today.getDate() - today.getDay());
                secondPayDate.setDate(firstPayDate.getDate() + 7);
                freq = "weekly";
                break;
            case "2": // Biweekly
                firstPayDate.setDate(today.getDate() - (today.getDay() + 7) % 14);
                secondPayDate.setDate(firstPayDate.getDate() + 14);
                freq = "biWeekly";
                break;
            case "3": // Semi-Monthly
                if (today.getDate() <= 15) {
                    firstPayDate.setDate(1);
                    secondPayDate.setDate(15);
                    freq = "semi-Monthly";
                } else {
                    firstPayDate.setDate(16);
                    secondPayDate.setDate(lastDayOfMonth.getDate());
                    freq = "semi-Monthly";
                }
                break;
            case "4": // Monthly
                firstPayDate.setDate(1);
                secondPayDate.setDate(lastDayOfMonth.getDate());
                freq = "monthly";
                break;
            case "5": // Annual
                firstPayDate.setMonth(0, 1);
                secondPayDate.setMonth(11, 31);
                freq = "annual";
                break;
            case 6: // Semi-Annual
                if (today.getMonth() < 6) {
                    firstPayDate.setMonth(0, 1);
                    secondPayDate.setMonth(5, 30);
                } else {
                    firstPayDate.setMonth(6, 1);
                    secondPayDate.setMonth(11, 31);
                }
                break;
            default:
                throw new Error('Invalid frequency');
        }

        if (isPast(firstPayDate)) {
            firstPayDate.setMonth(firstPayDate.getMonth() + 1); // Move to next month
            secondPayDate.setMonth(secondPayDate.getMonth() + 1); // Move to next month
        }

        // Adjust for weekends
        const adjFirstPayDate = adjustForWeekend(firstPayDate);
        const adjSecondPayDate = adjustForWeekend(secondPayDate);
        setFormData(prev => ({
            ...prev,
            nextPayDate: adjFirstPayDate,
            secondPayDate: adjSecondPayDate,
            payFrequency: freq,
        }))
    }

    const handleInput = (name, value) => {
        setFormData(prev => ({
            ...prev,
            [name]: value
        }))
        let formError = formHasError();
        setFormError(formError);
    }

    const handleValidation = () => {
        let formError = formHasError();
        setFormError(formError);
        return formError;
    };

    const formHasError = () => {
        let driversLicenseError = false;
        let driversLicenseStateError = false;
        let military = false;
        let bankNameError = false;
        let bankAccountTypeError = false;
        let bankAccountNumberError = false;
        let bankRoutingNumberError = false;
        let monthsAtBankError = false;


        let fieldErrors = [];

        setFieldErrors(prev => ({
            ...prev,
            fieldErrors: fieldErrors
        }));

        driversLicenseError =
            validator.isEmpty(formData.driversLicense + "") && !validator.isLength(formData.driversLicense, { min: 1, max: 20 });
        driversLicenseStateError =
            validator.isEmpty(formData.driversLicenseState + "") && !validator.isLength(formData.driversLicenseState, { min: 2, max: 2 });
        military =
            validator.isEmpty(formData.military + "") && !validator.isBoolean(formData.military);
        bankNameError =
            validator.isEmpty(formData.bankName + "") && !validator.isLength(formData.bankName, { min: 1, max: 255 });
        bankAccountNumberError =
            validator.isEmpty(formData.bankAccountNumber + "") && !validator.isLength(formData.bankAccountNumber, { min: 3, max: 30 });
        bankRoutingNumberError =
            validator.isEmpty(formData.bankRoutingNumber + "") && !validator.isLength(formData.bankRoutingNumber, { min: 9, max: 17 });
        monthsAtBankError =
            validator.isEmpty(formData.monthsAtBank + "");

        return (
            driversLicenseError ||
            driversLicenseStateError ||
            military ||
            bankNameError ||
            bankAccountTypeError ||
            bankAccountNumberError ||
            bankRoutingNumberError ||
            monthsAtBankError
        );
    }


    const handleSubmit = async () => {
        let formError = handleValidation();
        if (!formError) {

            const result = await newLoanService.getLeapTheoryDecision(formData);

            if (result.status === "rejected" || result.status === "error") {
                props.setDeclinedState(state => ({
                    ...state,
                    LeapTheoryDecision: "noOffers"
                }))
            }
            if (result.status === "accepted") {
                props.setDeclinedState(state => ({
                    ...state,
                    LeapTheoryDecision: "goodNews",
                    redirectURL: result.redirectURL
                }))
            }

            let newLoanInfo = JSON.parse(sessionStorage.getItem("newloanInfo"));
            newLoanInfo.LeapLeadId = result.leadID;
            newLoanInfo.PayModel = result.payModel;
            newLoanInfo.Payout = result.payout;
            await props.actions.soldNewLoan(newLoanInfo);
        }

    }

    return (
        <Card>
            <CardBody className="pt-0">
                <SlPageTitle pageName={"MoreInformation"} sectionName={"MoreInformation"} centered={true} />
                <Col>
                    <p className={"text-center"}>{metadataService.getMessage("MoreInformation")}</p>
                </Col>
                <SlFormEntryRow>
                    <SlSectionLabel pageTitle={"Identification"} sectionName={"Identification"} centered={true} />
                    <TextInput
                        name="DriversLicenseNumber"
                        onChange={(e) => { handleInput("driversLicense", e.target.value) }}
                        type="text"
                        value={formData.driversLicense}

                    />
                    <SlDropdown
                        Name="DriversLicenseState"
                        value={formData.driversLicenseState}
                        isRequired={true}
                        options={metadataService.getLookup("state")}
                        handleChange={(e) => { handleInput("driversLicenseState", e.target.value) }}
                        open={isStateSelectOpen}
                        openDropdown={() => { setStateSelectOpen(!isStateSelectOpen) }}
                        fieldErrors={fieldErrors}
                        showLabel={true}
                        placeholder={"Select " + metadataService.getFieldNameLabel("State")}
                    />
                    <Label className="required">{metadataService.getLabel("Veteran")}</Label>
                    <br />
                    <SlRadioButton
                        fieldName="Military"
                        value={1}
                        isSelected={formData.military}
                        onChange={(e) => { handleInput(e.target.name[0].toLowerCase() + e.target.name.slice(1), Number(e.target.value)) }}
                    >
                        {""}
                        {metadataService.getFieldNameLabel("Yes")}
                    </SlRadioButton>
                    <SlRadioButton
                        fieldName="Military"
                        value={0}
                        isSelected={!formData.military}
                        onChange={(e) => { handleInput(e.target.name[0].toLowerCase() + e.target.name.slice(1), Number(e.target.value)) }}
                    >
                        {""}
                        {metadataService.getFieldNameLabel("No")}
                    </SlRadioButton>
                </SlFormEntryRow>
                <SlFormEntryRow>
                    <SlSectionLabel sectionName={"BankingInfo"} centered={true} />
                    <TextInput
                        name="BankName"
                        onChange={(e) => { handleInput(e.target.name[0].toLowerCase() + e.target.name.slice(1), e.target.value) }}
                        type="text"
                        value={formData.bankName}
                        required={true}
                    />
                    <Label className="required">{metadataService.getLabel("BankAccountType")}</Label>
                    <br />
                    <SlRadioButton
                        fieldName="BankAccountType"
                        value={"checking"}
                        isSelected={formData.bankAccountType === "checking"}
                        onChange={(e) => { handleInput(e.target.name[0].toLowerCase() + e.target.name.slice(1), e.target.value) }}
                    >
                        {""}
                        {metadataService.getFieldNameLabel("Checking")}
                    </SlRadioButton>
                    <SlRadioButton
                        fieldName="BankAccountType"
                        value={"saving"}
                        isSelected={formData.bankAccountType === "saving"}
                        onChange={(e) => { handleInput(e.target.name[0].toLowerCase() + e.target.name.slice(1), e.target.value) }}
                    >
                        {""}
                        {metadataService.getFieldNameLabel("Saving")}
                    </SlRadioButton>
                    <TextInput
                        name="RoutingNumber"
                        onChange={(e) => { handleInput("bank" + e.target.name, e.target.value) }}
                        type="text"
                        value={formData.bankRoutingNumber}
                        required={true}
                    />
                    <TextInput
                        name="AccountNumber"
                        onChange={(e) => { handleInput("bank" + e.target.name, e.target.value) }}
                        type="text"
                        value={formData.bankAccountNumber}
                        required={true}
                    />
                    <TextInput
                        name="BankMonths"
                        type="number"
                        label={metadataService.getFieldNameLabel("BankMonths")}
                        placeholder={metadataService.getFieldNameLabel("BankMonths")}
                        value={formData.monthsAtBank}
                        fieldErrors={fieldErrors}
                        isRequired={true}
                        showLabel={true}
                        min={0}
                        maxLength={2}
                        onChange={(e) => { handleInput("monthsAtBank", e.target.value) }}
                    />
                </SlFormEntryRow>
                <div className={"text-center"}>
                    <SlButton name={"Submit"} size={"lg"} className={"text-center"} onClick={handleSubmit} disabled={formError} />
                </div>
            </CardBody>
        </Card>
    );

};

function mapStateToProps(store) {

    const { firstName, lastName, email, confirmEmail, mobileNumber, alternateMobileNumber, address1, address2, city, userState, state, postalCode, requestedAmount, socialSecurityNumber, individualTaxIdentificationNumber, years, months, dateOfBirth, completedSteps, formState, step } = store.registration;
    const employers = store.financialInfo.employers ? store.financialInfo.employers : undefined;
    const incomes = store.financialInfo.incomes ? store.financialInfo.incomes : undefined
    const financeInfo = store.financeInfo;
    const { language } = store.users;


    return {
        firstName, lastName, email, confirmEmail, mobileNumber, alternateMobileNumber, address1, address2, city, userState: userState ? userState : state, postalCode, requestedAmount, socialSecurityNumber, individualTaxIdentificationNumber, years, months, dateOfBirth, completedSteps, formState, step,
        employers,
        incomes, financeInfo, language,
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        actions: {
            soldNewLoan: (data) => {
                dispatch(newLoanActions.soldNewLoan(data));
            },
        },
        unexpectedError: () => {
            dispatch(newLoanActions.unexpectedError(metadataService.getMessage("AnUnexpectedErrorHasOcurred")));
        }
    }
}

const LeapTheoryForm = withRouter(leapTheoryForm);
const connectedLeapTheoryForm = connect(mapStateToProps, mapDispatchToProps)(LeapTheoryForm);
export { connectedLeapTheoryForm as LeapTheoryForm };


// WEBPACK FOOTER //
// ./src/components/subcomponents/LeapTheoryForm.jsx